import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState } from '../../../../types/types';
import { getActiveNotification } from '../store/notifications/selectors/getActiveNotification';
import { recentNotificationSetAction } from '../store/notifications/actions/recentNotificationSetAction';
import { activeNotificationSetAction } from '../store/notifications/actions/activeNotificationSetAction';

export const setActiveNotification = (
    activeNotification: number
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const currentActiveNotification = getActiveNotification(getState());
        if (activeNotification === currentActiveNotification) return;
        if (currentActiveNotification) {
            dispatch(recentNotificationSetAction(currentActiveNotification));
        }
        $(document).find('.notification-group--active')
            .removeClass('notification-group--active');

        return dispatch(activeNotificationSetAction(activeNotification))
    };
    return action;
};
